import { Component, Input } from '@angular/core';
import { ContactData } from 'src/app/meta/ContactData.interface';
import { PortingData } from 'src/app/meta/PortingData.interface';

@Component({
  selector: 'ow-phone-book-entry',
  templateUrl: './phone-book-entry.component.html'
})
export class PhoneBookEntryComponent {

  @Input() type: "full" | "short" | null = null
  @Input() contactData: ContactData | null = null
  @Input() portingData: PortingData | null = null
  @Input() streetName: string = ""
  @Input() streetNumber: string = ""
  @Input() postalCode: string = ""
  @Input() city: string = ""

}
